import { LoadingState } from "@repo/app-types/client/client";
import { type FC, useEffect, useState } from "react";
import { getAxiosInstanceWithAuth } from "../../../api/axiosConfig.js";

export const WebhooksSettingsSection: FC = () => {
  const [portalUrl, setPortalUrl] = useState<string | null>(null);
  const [loadingState, setLoadingState] = useState<LoadingState>(
    LoadingState.LOADING,
  );

  const fetchWebhookPortalUrl = async () => {
    setLoadingState(LoadingState.LOADING);
    try {
      const axios = await getAxiosInstanceWithAuth();
      const { data } = await axios.get(`/company/webhooks-session`);
      setPortalUrl(data.url);
      setLoadingState(LoadingState.LOADED);
    } catch (err) {
      setLoadingState(LoadingState.ERROR);
    }
  };

  useEffect(() => {
    fetchWebhookPortalUrl();
  }, []);

  if (loadingState === LoadingState.LOADING) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-indigo-600" />
      </div>
    );
  }

  if (loadingState === LoadingState.ERROR) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-red-500">
          Failed to load webhook portal. Please try again later.
        </div>
      </div>
    );
  }

  if (!portalUrl) {
    return null;
  }

  return (
    <div className="h-full w-full">
      <iframe
        src={portalUrl}
        allow="clipboard-write"
        className="h-full w-full border-0"
        title="Webhook portal"
      />
    </div>
  );
};
